import { forwardRef } from "react";
import { ScrollView, ScrollViewProps } from "react-native";

export const VnScrollView = forwardRef<ScrollView, ScrollViewProps>(
  (props, ref) => {
    return <ScrollView ref={ref} {...props} />;
  },
);

VnScrollView.displayName = "VnScrollView";
